<template>
  <li :class="{ comer: data.ticket_en == 1 }">
    <i
      v-if="data.ticket_status == 1 || data.ticket_status == 100"
      :class="{
        used: data.ticket_status == 1,
        use_status: true,
        expire: data.ticket_status == 100
      }"
    ></i>
    <span class="new_member" v-if="data.ticket_en == 1">新人券</span>
    <div class="left">
      <div class="counpon_price">
        <i v-if="data.ticket_type == 1">¥</i>
        <span>{{
          data.ticket_type == 1
            ? data.ticket_money / 100
            : data.ticket_rate / 10
        }}</span>
        <i v-if="data.ticket_type == 2">折</i>
      </div>
      <div v-if="data.ticket_type == 1" class="coupon_desc">
        {{ data.reach ? `满${data.reach / 100}元可用` : '下单立减' }}
      </div>
      <div class="coupon_desc" v-else>
        最高减{{ data.ticket_money / 100 }}元
      </div>
    </div>
    <div class="right">
      <div class="name fs">
        <span class="couponType">{{ data | filterBusiness }}</span>
        <div class="coupon_name">
          {{ data.packet_name }}
        </div>
      </div>
      <div class="time">
        有效期：{{ data.start_time | toDate }}-{{ data.end_time | toMonth }}
      </div>
      <button
        @click="useCoupon"
        :class="{ dis: data.ticket_status != 0 }"
        v-if="[0, 1].includes(Number(data.ticket_status))"
      >
        {{ data.ticket_status == 1 ? '已使用' : '立即使用' }}
      </button>
    </div>
  </li>
</template>

<script>
import { formatTime } from '@/utils';
import { useCoupon } from '@/components/js/lalaPrize/lalaCoupon';
export default {
  props: ['index', 'data'],
  filters: {
    filterBusiness(value) {
      let { business_type } = value;
      switch (Number(business_type)) {
        case 1:
          return '通用券';
        case 2:
          return '搬家券';
        case 3:
          return '大货车';
        case 4:
          return '货运券';
        case 5:
          return '零担物流';
      }
    },
    toMonth(v) {
      return (
        v && formatTime('MM.dd', new Date(v ? v.replace(/[-]/g, '/') : ''))
      );
    },
    toDate(v) {
      return (
        v && formatTime('yyyy.MM.dd', new Date(v ? v.replace(/[-]/g, '/') : ''))
      );
    }
  },
  data() {
    return {};
  },
  methods: {
    useCoupon() {
      if (this.data.ticket_status != 0) return false;
      this.visitLog('分享者主页', '优惠券【立即使用】', {
        page_title: '每日拼手气活动'
      });
      return useCoupon(this.data.business_type); //默认处理
      // if (isHllApp()) {
      //   location.href = `hlluapp://https://0x7.me/AKsJW`;
      // } else if (isWxMiniProgram()) {
      //   wx &&
      //     wx.miniProgram.reLaunch({
      //       url: '/pages/home/index'
      //     });
      // } else {
      //   location.href = `https://m.huolala.cn`;
      // }
    }
  }
};
</script>

<style lang="less" scoped>
li {
  width: 100%;
  height: 152px;
  margin-bottom: 33px;
  display: flex;
  align-items: center;
  position: relative;
  background: url('../assets/coupon/coupon_bg.png') no-repeat center center;
  background-size: 100% 100%;
  color: #fff;
  &.comer {
    background-image: url('../assets/coupon/coupon_bg2.png');
    .couponType,
    button {
      color: #241cff !important;
    }
  }
  .use_status {
    background: transparent no-repeat center center;
    background-size: contain;
    display: inline-block;
    position: absolute;
    top: 0px;
    right: 0px;
    &.used {
      width: 60px;
      height: 54px;
      background-image: url('../assets/coupon/coupon_status1.png');
    }
    &.expire {
      width: 125px;
      height: 118px;
      background-image: url('../assets/coupon/coupon_status2.png');
    }
  }
  .new_member {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 97px;
    height: 32px;
    background: #ffdc66;
    border-radius: 0px 16px 16px 0px;
    display: inline-block;
    color: #f77258;
    font-size: 24px;
    text-align: center;
    line-height: 32px;
  }
  .left {
    flex: 0 0 166px;
    text-align: center;
    height: 100px;
    padding-bottom: 10px;
    border-right: solid 1px #fff;
    .counpon_price {
      height: 72px;
      i {
        font-size: 32px;
      }
      span {
        margin-left: 6px;
        font-size: 72px;
        height: 72px;
        line-height: 72px;
      }
    }
    .coupon_desc {
      font-size: 22px;
    }
  }
  .right {
    padding-left: 21px;
    .name {
      font-size: 32px;
      margin-bottom: 10px;
      .couponType {
        padding: 4px 9px 3px;
        margin-right: 13px;
        height: 24px;
        line-height: 24px;
        border-radius: 4px;
        font-size: 24px;
        font-weight: 400;
        background: rgba(249, 249, 249, 1);
        color: rgba(228, 61, 35, 1);
      }
      .coupon_name {
        max-width: 7em;
        font-size: 28px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .time {
      font-size: 23px;
      -webkit-text-size-adjust: none;
    }
    button {
      width: 139px;
      height: 50px;
      background: #fff;
      position: absolute;
      top: 56px;
      padding: 0px;
      right: 24px;
      font-size: 24px;
      color: #f77258ff;
      border-radius: 25px;
      &.dis {
        opacity: 0.6;
      }
    }
  }
}
</style>
